import {observable, action} from 'mobx';

class Notification {
    constructor(message, id){
        this.message = message
        this.id = id
    }
    message = ''
    id = null
}

class NotificationsStore {

    nextId = 0
    maxActiveNotifications = 3

    @observable.shallow
    activeNotifications =[]

    notificationsQueue = []

    @action
    pushNotification(message, time=3000) {
        this.notificationsQueue.push(new Notification(message, this.nextId++))
        if(this.activeNotifications.length >= this.maxActiveNotifications){
            this.activeNotifications.splice(0, 1)
        }
        let newNotification = this.notificationsQueue[0]
        this.activeNotifications.push(newNotification)
        setTimeout(() => {this.hideNotification(newNotification.id)}, time)
        this.notificationsQueue.splice(0, 1)
    }

    @action
    hideNotification(id) {
        let index = this.activeNotifications.findIndex(n => n.id === id)
        if(index > -1) {
            this.activeNotifications.splice(index, 1)
        }
    }


}

const notificationsStore = new NotificationsStore()

export default notificationsStore;


// WEBPACK FOOTER //
// ./src/store/NotificationsStore.js